<footer>
  <div class="container">
    <div class="footer-inner">

      <!-- Brand CTA -->
      <div>
        <p class="footer-cta-heading">SLB digital marketplace</p>
        <p class="footer-brand-desc">Discover and deploy enterprise-grade AI solutions. Operate smarter by quickly crafting your own digital ecosystem with confidence.</p>
        <app-button variant="outline" routerLink="/catalog">Browse catalog →</app-button>
        <div class="footer-brand-logo">
          <a href="https://www.slb.com" target="_blank" rel="noopener noreferrer" aria-label="Visit slb.com">
            <img
              src="assets/images/logos/SLB/SLB_100_White_Logo.webp"
              alt="SLB"
              width="267"
              height="60"
              class="footer-brand-logo-img">
          </a>
        </div>
      </div>

      <!-- Marketplace -->
      <div class="footer-col">
        <h4>Marketplace</h4>
        <ul>
          <li><a [routerLink]="['/catalog']" [queryParams]="{filter: 'Tela'}">Tela</a></li>
          <li><a [routerLink]="['/catalog']" [queryParams]="{highlight: 'Spotlight'}">Spotlight</a></li>
          <li><a [routerLink]="['/catalog']" [queryParams]="{highlight: 'New'}">New Releases</a></li>
        </ul>
      </div>

      <!-- Ecosystem -->
      <div class="footer-col">
        <h4>Ecosystem</h4>
        <ul>
          <li><a href="https://developer.slb.com/" target="_blank" rel="noopener noreferrer">SLB developer website</a></li>
          <li><a href="https://developer.slb.com/apis" target="_blank" rel="noopener noreferrer">API Reference</a></li>
          <li><a routerLink="/partners" (click)="onBecomAPartnerClick($event)">Become a Partner</a></li>
        </ul>
      </div>

      <!-- Follow SLB -->
      <div class="footer-col">
        <h4>Follow SLB</h4>
        <div class="footer-social">

          <!-- LinkedIn -->
          <a href="https://www.linkedin.com/company/slbglobal/" target="_blank" rel="noopener noreferrer" aria-label="Visit SLB's LinkedIn profile">
            <svg viewBox="0 0 24 24" width="25" height="25" fill="currentColor" aria-hidden="true">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>

          <!-- YouTube -->
          <a href="https://www.youtube.com/channel/UCzX5PhHCet4oAi_iTutUo5Q" target="_blank" rel="noopener noreferrer" aria-label="Visit SLB's YouTube channel">
            <svg viewBox="0 0 24 24" width="25" height="25" fill="currentColor" aria-hidden="true">
              <path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
            </svg>
          </a>

          <!-- Facebook -->
          <a href="https://www.facebook.com/WeAreSLBGlobal" target="_blank" rel="noopener noreferrer" aria-label="Visit SLB's Facebook page">
            <svg viewBox="0 0 24 24" width="25" height="25" fill="currentColor" aria-hidden="true">
              <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
            </svg>
          </a>

          <!-- Instagram -->
          <a href="https://www.instagram.com/slb_global/" target="_blank" rel="noopener noreferrer" aria-label="Visit SLB's Instagram profile">
            <svg viewBox="0 0 24 24" width="25" height="25" fill="currentColor" aria-hidden="true">
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12c0 3.259.015 3.668.072 4.948.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.668-.015 4.948-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.689.072-4.948 0-3.259-.015-3.667-.072-4.947-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>

        </div>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <span>Copyright &copy; 2026 SLB. All rights reserved.</span>
      <div class="footer-bottom-links">
        <a href="https://www.slb.com/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
        <a href="https://www.slb.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        <a href="#" (click)="openPreferences($event)">Preferences</a>
      </div>
    </div>
  </div>
</footer>
